export const KAS_LOGIN_USERNAME = "ka$";
export const KAS_LOGIN_PASSWORD = "pwd321$";
